// extracted by mini-css-extract-plugin
export default {"estilo":"estilo_estilo__oh7kt","datos":"estilo_datos__0ZOfX"};